export default __webpack_public_path__ + "static/media/12.ec43020a.jpg";